import { PortableTextBlock } from "@sanity/types";
import SSectionHeader from "components/framework/SSectionHeader";
import Icons, { CUSTOM_ICONS } from "components/images/Icons";
import RichText from "components/richtext/RichText";
import { INewsArticleWithIcon } from "lib/types/Frontpage";
import { getUrlForDocType, ISpecialShowArticle } from "lib/types/sanity";
import Link from "next/link";
import styles from "./ArticleWithIconContainer.module.css";


//#region [Props]

type ArticleWithIconContainerProps = {
    articleList?: (ISpecialShowArticle | INewsArticleWithIcon)[];
};
//#endregion

//#region [Component]
export default function ArticleWithIconContainer({ articleList }: ArticleWithIconContainerProps) {
    const artList = articleList?.filter(art => !!art?._id);
    if ((artList?.length ?? 0) === 0) {
        return null;
    }
    return <section className={styles.SArticleWithIconContainer}>
        {artList?.map(article => <Article key={article._id} article={article} />)}
    </section>
}
//#endregion


//#region [Props]
type ArticleProps = {
    article: (ISpecialShowArticle | INewsArticleWithIcon);
}
//#endregion

//#region [Component]
function Article({ article }: ArticleProps) {
    const url = getUrlForDocType(article._type, article.slug);
    if (!url) {
        return null;
    }
    return <Link href={url} passHref legacyBehavior>
        <a className={styles.SArticle}>
            <>
                {article.customIcon && CUSTOM_ICONS[article.customIcon!]}
                {!article.customIcon && article.icon && Icons[article.icon!]}
                <SSectionHeader className={styles.SArticleListTitle} as="h2">{article.title}</SSectionHeader>
                {(article.frontpageText || article.ingress) && <RichText disableLinks value={(article.frontpageText ?? article.ingress) as PortableTextBlock[]} />}

                <div className={styles.SReadMore}>Les mer</div>
            </>
        </a>
    </Link>

}
//#endregion